import React, { forwardRef } from 'react'
import classNames from 'classnames'
import { getTextareaBaseClasses, getInputLabelClasses, getInputHelperTextClasses } from '../utils/inputStyles'

export interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string
  error?: boolean
  helperText?: string
}

const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ label, error, helperText, className = '', disabled, value, id, ...props }, ref) => {
    const textareaClasses = getTextareaBaseClasses(error, disabled, className)

    return (
      <div className="w-full">
        {label && (
          <label 
            htmlFor={id} 
            className={getInputLabelClasses()}
          >
            {label}
          </label>
        )}
        <textarea
          ref={ref}
          id={id}
          disabled={disabled}
          className={classNames(textareaClasses, 'mt-0')}
          value={value === null ? '' : value}
          {...props}
        />
        {helperText && (
          <p className={getInputHelperTextClasses(error)}>
            {helperText}
          </p>
        )}
      </div>
    )
  }
)

Textarea.displayName = 'Textarea'

export default Textarea

